import UpdateAssetForm from "@/admin/asset/update/form/UpdateAssetForm"
import Relay from "@/relay/relayUtils"
import { graphql, useLazyLoadQuery } from "react-relay"
import { RenameMediaAssetFormQuery } from "./__generated__/RenameMediaAssetFormQuery.graphql"
import { DiscoSpinner } from "@disco-ui"
interface Props {
  uploadedAssetId: string
  onClose: () => void
}

function RenameMediaAssetForm(props: Props) {
  const { uploadedAssetId, onClose } = props

  const { node } = useLazyLoadQuery<RenameMediaAssetFormQuery>(
    graphql`
      query RenameMediaAssetFormQuery($id: ID!) {
        node(id: $id) {
          __typename
          ... on Asset {
            ...UpdateAssetFormFragment
          }
        }
      }
    `,
    { id: uploadedAssetId }
  )
  const asset = Relay.narrowNodeType(node, "Asset")
  if (!asset) return null

  return <UpdateAssetForm assetKey={asset} onClose={onClose} />
}

function RenameMediaAssetFormSkeleton() {
  return <DiscoSpinner />
}

export default Relay.withSkeleton({
  component: RenameMediaAssetForm,
  skeleton: RenameMediaAssetFormSkeleton,
})
